/** Stable, lowercase URL segment for each tab ("Meal Map" → "meal-map"). */
export const HOME_TAB_PATHS = {
    Profile: 'profile',
    'Meal Map': 'meal-map',
    Summary: 'summary',
    Trends: 'trends',
    Photos: 'photos',
    History: 'history',
};
export const CLIENT_HOME_TABS = [
    'Profile',
    'Meal Map',
    'Summary',
    'Trends',
    'Photos',
];
export const ADMIN_HOME_TABS = [
    'Profile',
    'Meal Map',
    'Summary',
    'Trends',
    'History',
    'Photos',
];
/** Tab named by a `/Home/<segment>` path (case-insensitive), or undefined. */
export function tabFromPathname(pathname) {
    if (!pathname) {
        return undefined;
    }
    const parts = pathname
        .split(/[?#]/)[0]
        .split('/')
        .filter(Boolean)
        .map(p => {
        try {
            return decodeURIComponent(p).toLowerCase();
        }
        catch {
            return p.toLowerCase();
        }
    });
    if (parts.length < 2 || parts[0] !== 'home') {
        return undefined;
    }
    const seg = parts[1].replace(/\s+/g, '-');
    return Object.keys(HOME_TAB_PATHS).find(name => HOME_TAB_PATHS[name] === seg);
}
/** URL tab wins, then the saved tab, then the default; each must be allowed. */
export function resolveInitialHomeTab(opts) {
    const fromUrl = tabFromPathname(opts.pathname);
    if (fromUrl && opts.allowed.includes(fromUrl)) {
        return fromUrl;
    }
    if (opts.saved && opts.allowed.includes(opts.saved)) {
        return opts.saved;
    }
    return opts.fallback;
}
/**
 * Web Home side panel: admins only, and hidden on a landscape phone (#407)
 * or a phone-width window (#411, client list screen instead) so the
 * selected client's tabs get the full width. Clients never get it.
 */
export function shouldShowSidePanel(opts) {
    return !opts.clientHeader && !opts.isLandscapePhone && !opts.isNarrowWindow;
}
export function adminPhoneView(opts) {
    if (!opts.isAdmin || !(opts.isNarrowWindow || opts.isLandscapePhone)) {
        return 'none';
    }
    return opts.hasClient ? 'client' : 'list';
}
